<div class="custom-breadcrumb">
  <!-- <img *ngIf="currentRoute!=='/admin'" routerLink="/admin" routerLinkActive="router-link-active"  class="cursor-pointer mr-2" src='../../../assets/general/to-na-wiz/admin/arrow-left.svg' alt=""> -->
  <span routerLink="/admin" class="cursor-pointer font-home mr-2">HOME</span>
  <img *ngIf="currentRoute!=='/admin'" class="mr-2" src='../../../assets/general/to-na-wiz/admin/path-right.svg' alt="">
  <span class="font-actual-page">{{ nameToCurrentRoute }}</span>
</div>
